<template>
  <div class="content content-box">
    <router-link :to="link" class="box-container">
      <div class="box is-flex is-horizontal-center">
        <figure class="image">
          <img :src="image">
        </figure>
      </div>
      <div class="box-title">
        {{title}}
      </div>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'Box',
    props: ['title', 'link', 'image']

  }
</script>



// WEBPACK FOOTER //
// src/components/Box.vue